import React from "react";
import { min } from "lodash";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { pickPercent } from "./utils";
import FormulaTable from "./FormulaTable";

const CostOfCapital = ({ teams, competitionMetrics, metrics }) => {
  const debtWeight = min([metrics["Debt to Total Capital"], 0.99]);
  const equityWeight = 1 - debtWeight;
  const costOfDebt = metrics["Bond Yield"] * (1 - metrics["Tax Rate"]);
  const costOfEquity = metrics["Required Rate of Return"];
  const wacc = debtWeight * costOfDebt + equityWeight * costOfEquity;
  return (
    <OnePanelChart
      title="Cost of Capital"
      chartTitle="Cost of Capital Ratio"
      vertical
      suffix="%"
      data={pickPercent(teams, competitionMetrics, "WACC")}
      teams={teams}
    >
      <Text>
        Your Cost of Capital (i.e. WACC) is the weighted average costs of
        raising both equity and debt capital.
      </Text>
      <FormulaTable
        items={[
          {
            name: "WACC",
            highlighted: true,
            value: `${(wacc * 100).toFixed(2)}%`
          },
          { name: "=", highlighted: false, value: "=" },
          {
            name: "Cost of Equity",
            highlighted: true,
            value: `${(costOfEquity * 100).toFixed(2)}%`
          },
          { name: "×", highlighted: false, value: "×" },
          {
            name: "Equity Weight",
            highlighted: true,
            value: `${(equityWeight * 100).toFixed(2)}%`
          },
          { name: "+", highlighted: false, value: "+" },
          {
            name: "Cost of Debt",
            highlighted: true,
            value: `${(costOfDebt * 100).toFixed(2)}%`
          },
          { name: "×", highlighted: false, value: "×" },
          {
            name: "Debt weight",
            highlighted: true,
            value: `${(debtWeight * 100).toFixed(2)}%`
          }
        ]}
      />
      <Text style={{ marginTop: "1em" }}>
        <b>Note</b>: Higher cost of capital signals higher risks. Equity
        investors will use the cost of capital metric to value your team in
        Round 5 and beyond. This will have a direct impact to your Share Price.
      </Text>
      {wacc > 0.5 && (
        <Text>A 50% cap is placed on your team’s cost of capital ratio</Text>
      )}
    </OnePanelChart>
  );
};

export default CostOfCapital;



// WEBPACK FOOTER //
// ./src/components/analysis/CostOfCapital.js